/**
 * Wrapper for sessionStorage that swallows errors thrown by the storage (e.g. blocked storage, quota)
 * so reads return null and writes are no-ops instead of throwing
 */
const sessionStorageHelper = {
  setItem(key: string, item: string) {
    try {
      window.sessionStorage.setItem(key, item);
    } catch {
      // noop
    }
  },

  getItem(key: string): string | null {
    try {
      return window.sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },

  removeItem(key: string) {
    try {
      window.sessionStorage.removeItem(key);
    } catch {
      // noop
    }
  },
};

export { sessionStorageHelper };
